import React, { useContext } from 'react'
import { api } from '../api/axios';
import { toast } from 'react-toastify';
import { AuthContext } from '../context/AuthContext';



export default function MeetingForm() {
    const { setLoading } = useContext(AuthContext);

    const handelRegisterNewMeeting = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData(e.target);
        const data = Object.fromEntries(formData.entries());

        try {
            const respons = await api.post('/meetings', data)

            if (respons.status === 201) return toast.success("Meeting Created Successfully")
        } catch (error) {

            toast.error("Meeting Created Error")
            console.error("Meeting Created Error:", error);
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 1000)
        }

    }


    return (
        <>
            <form onSubmit={handelRegisterNewMeeting}>
                <div className="border-b border-gray-900/10 pb-6">
                    <h2 className="text-base font-semibold text-gray-900">Meeting Information</h2>

                    <div className="mt-4 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-8 ms-5">
                        <div className="sm:col-span-5">
                            <label htmlFor="title" className="block text-sm/6 font-medium text-gray-900">
                                Title <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <input
                                    id="title"
                                    name="title"
                                    type="text"

                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-2">
                            <label htmlFor="date" className="block text-sm/6 font-medium text-gray-900">
                                Date <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <input
                                    id="date"
                                    name="date"
                                    type="date"

                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-1">
                            <label htmlFor="time" className="block text-sm/6 font-medium text-gray-900">
                                Time <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <input
                                    id="time"
                                    name="time"
                                    type="time"

                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                />
                            </div>
                        </div>
                        <div className="sm:col-span-8">
                            <label htmlFor="description" className="block text-sm/6 font-medium text-gray-900">
                                Description <span className='text-sm text-red-400'>*</span>
                            </label>
                            <div className="mt-3">
                                <textarea
                                    id="description"
                                    name="description"
                                    type="text"

                                    required={true}
                                    className="px-3 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-green-600 sm:text-sm/6"
                                ></textarea>
                            </div>
                        </div>


                        <div className="col-span-full flex items-center justify-end gap-x-6">
                            <button
                                type="submit"
                                className="rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600"
                            >
                                Save New Meeting
                            </button>
                        </div>
                    </div>
                </div>

            </form>

        </>
    )
}
